/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} years, ${i?.months} months, ${i?.days} days`)
};

const es_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} años, ${i?.months} meses, ${i?.days} días`)
};

const de_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} Jahre, ${i?.months} Monate, ${i?.days} Tage`)
};

const nl_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} jaren, ${i?.months} maanden, ${i?.days} dagen`)
};

const fr_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} ans, ${i?.months} mois, ${i?.days} jours`)
};

const it_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} anni, ${i?.months} mesi, ${i?.days} giorni`)
};

const pt_br2_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} anos, ${i?.months} meses, ${i?.days} dias`)
};

const pt_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} anos, ${i?.months} meses, ${i?.days} dias`)
};

const ja_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} 年、${i?.months} ヶ月、${i?.days} 日`)
};

const zh_dd_ymd = /** @type {(inputs: { years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} 年 ${i?.months} 个月 ${i?.days} 天`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ years: NonNullable<unknown>, months: NonNullable<unknown>, days: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_ymd = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_ymd(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_ymd", locale)
	if (locale === "en") return en_dd_ymd(inputs)
	if (locale === "es") return es_dd_ymd(inputs)
	if (locale === "de") return de_dd_ymd(inputs)
	if (locale === "nl") return nl_dd_ymd(inputs)
	if (locale === "fr") return fr_dd_ymd(inputs)
	if (locale === "it") return it_dd_ymd(inputs)
	if (locale === "pt-BR") return pt_br2_dd_ymd(inputs)
	if (locale === "pt") return pt_dd_ymd(inputs)
	if (locale === "ja") return ja_dd_ymd(inputs)
	return zh_dd_ymd(inputs)
};